import React from 'react';
import PropTypes from 'prop-types';
import copy from 'clipboard-copy';

import FileCopyOutlinedIcon from '@mui/icons-material/FileCopyOutlined';
import Tooltip from '@mui/material/Tooltip';
import {styled} from '@mui/system';


const StyledFileCopyOutlinedIcon = styled(FileCopyOutlinedIcon)({
    margin: '0 0 0 10px',
    verticalAlign: 'middle',
    fontSize: 'medium',
    cursor: 'pointer'
});


class CopyToClipboard extends React.Component {
    constructor(props) {
        super(props);
    }

    stopPropagation = (event) => {
        event.stopPropagation();
    };

    copyAction = (event) => {
        this.stopPropagation(event);
        copy(this.props.value);
    };

    render() {
        return (
            <Tooltip title={`Copy ${this.props.value} to the clip board`}>
                <StyledFileCopyOutlinedIcon onClick={this.copyAction} color="primary" />
            </Tooltip>
        );
    }

}

CopyToClipboard.propTypes = {
    value: PropTypes.string.isRequired
};

export default CopyToClipboard;
